(function () {
  'use strict';

  // ─── THEME ───────────────────────────────────────────────────────────────────
  const savedTheme = localStorage.getItem('mt-theme') || 'light';
  document.body.setAttribute('data-theme', savedTheme);

  function applyTheme(theme) {
    document.body.setAttribute('data-theme', theme);
    localStorage.setItem('mt-theme', theme);

    // Logo swap
    document.querySelectorAll('.mt-theme-logo').forEach(function (img) {
      img.src = theme === 'dark' ? img.dataset.darkSrc : img.dataset.lightSrc;
    });

    // Transition image swap
    document.querySelectorAll('.mt-theme-transition-img').forEach(function (img) {
      img.src = theme === 'dark' ? img.dataset.darkSrc : img.dataset.lightSrc;
    });
  }

  applyTheme(savedTheme);

  const themeToggle = document.getElementById('mt-theme-toggle');
  if (themeToggle) {
    themeToggle.addEventListener('click', function () {
      const current = document.body.classList.contains('mt-theme-dark') ? 'dark' : 'light' || 'light';
      applyTheme(current === 'light' ? 'dark' : 'light');
    });
  }

  // ─── NAV SCROLL ──────────────────────────────────────────────────────────────
  const nav = document.getElementById('mt-nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      nav.classList.toggle('is-scrolled', window.scrollY > 60);
    }, { passive: true });
  }

  // ─── MEGA MENU ───────────────────────────────────────────────────────────────
  let megaTimeout = null;

  function openMega(key) {
    clearTimeout(megaTimeout);
    document.querySelectorAll('.mt-mega').forEach(function (m) { m.style.display = 'none'; });
    const mega = document.getElementById('mt-mega-' + key);
    if (mega) mega.style.display = 'block';
  }

  function closeMega() {
    megaTimeout = setTimeout(function () {
      document.querySelectorAll('.mt-mega').forEach(function (m) { m.style.display = 'none'; });
      document.querySelectorAll('.mt-nav__item').forEach(function (i) { i.classList.remove('is-active'); });
    }, 180);
  }

  document.querySelectorAll('.mt-nav__item[data-mega]').forEach(function (item) {
    item.addEventListener('mouseenter', function () {
      document.querySelectorAll('.mt-nav__item').forEach(function (i) { i.classList.remove('is-active'); });
      item.classList.add('is-active');
      openMega(item.dataset.mega);
    });
    item.addEventListener('mouseleave', closeMega);
  });

  document.querySelectorAll('.mt-mega').forEach(function (mega) {
    mega.addEventListener('mouseenter', function () { clearTimeout(megaTimeout); });
    mega.addEventListener('mouseleave', closeMega);
  });

  // ─── MOBILE MENU ─────────────────────────────────────────────────────────────
  var mobileToggle = document.getElementById('mt-mobile-toggle');
  var mobileMenu = document.getElementById('mt-mobile-menu');
  var mobileOpen = false;

  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', function () {
      mobileOpen = !mobileOpen;
      mobileMenu.style.display = mobileOpen ? 'block' : 'none';
      mobileToggle.querySelector('.icon-menu').style.display = mobileOpen ? 'none' : 'block';
      mobileToggle.querySelector('.icon-close').style.display = mobileOpen ? 'block' : 'none';
      document.querySelectorAll('.mt-mega').forEach(function (m) { m.style.display = 'none'; });
    });

    // Alleen gewone links sluiten het menu, niet de toggle buttons
    mobileMenu.querySelectorAll('a.mt-mobile-menu__item, a.mt-mobile-menu__subitem').forEach(function (item) {
      item.addEventListener('click', function () {
        mobileOpen = false;
        mobileMenu.style.display = 'none';
        mobileToggle.querySelector('.icon-menu').style.display = 'block';
        mobileToggle.querySelector('.icon-close').style.display = 'none';
      });
    });

    // Accordeon subitems
    mobileMenu.querySelectorAll('.mt-mobile-menu__toggle').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var sub = toggle.nextElementSibling;
        var isOpen = sub.style.display === 'block';
        sub.style.display = isOpen ? 'none' : 'block';
        toggle.textContent = toggle.textContent.replace(isOpen ? '▴' : '▾', isOpen ? '▾' : '▴');
      });
    });
  }

  // ─── HERO 3D LOGO ────────────────────────────────────────────────────────────
  const scene = document.getElementById('mt-hero-scene');
  const hero = document.querySelector('.mt-hero');

  if (scene && hero) {
    const maxX = 50;
    const maxY = 50;
    const baseX = 0;
    const baseY = 0;
    let targetX = baseX;
    let targetY = baseY;
    let currentX = baseX;
    let currentY = baseY;
    let hasGyro = false;
    let frameId = null;

    function lerp(a, b, amount) {
      return a + (b - a) * amount;
    }

    function tick() {
      currentX = lerp(currentX, targetX, 0.07);
      currentY = lerp(currentY, targetY, 0.07);

      scene.style.transform =
        'rotateX(' + currentX.toFixed(3) + 'deg) rotateY(' + currentY.toFixed(3) + 'deg)';

      frameId = window.requestAnimationFrame(tick);
    }

    function startAnimation() {
      if (frameId === null) {
        frameId = window.requestAnimationFrame(tick);
      }
    }

    function stopAnimation() {
      if (frameId !== null) {
        window.cancelAnimationFrame(frameId);
        frameId = null;
      }
    }

    hero.addEventListener('mousemove', function (event) {
      const rect = hero.getBoundingClientRect();
      const pointerX = (event.clientX - rect.left - rect.width / 2) / (rect.width / 2);
      const pointerY = (event.clientY - rect.top - rect.height / 2) / (rect.height / 2);

      targetY = baseY + Math.max(-1, Math.min(1, pointerX)) * maxY;
      targetX = baseX - Math.max(-1, Math.min(1, pointerY)) * maxX;
    }, { passive: true });

    hero.addEventListener('mouseleave', function () {
      targetX = baseX;
      targetY = baseY;
    });

    hero.addEventListener('touchmove', function (event) {
      if (hasGyro || !event.touches.length) return;

      const rect = hero.getBoundingClientRect();
      const touch = event.touches[0];
      const touchX = (touch.clientX - rect.left - rect.width / 2) / (rect.width / 2);
      const touchY = (touch.clientY - rect.top - rect.height / 2) / (rect.height / 2);

      targetY = baseY + Math.max(-1, Math.min(1, touchX)) * maxY;
      targetX = baseX - Math.max(-1, Math.min(1, touchY)) * maxX;
    }, { passive: true });

    hero.addEventListener('touchend', function () {
      if (!hasGyro) {
        targetX = baseX;
        targetY = baseY;
      }
    }, { passive: true });

    if (window.DeviceOrientationEvent) {
      window.addEventListener('deviceorientation', function (event) {
        if (event.gamma === null) return;

        hasGyro = true;
        targetY = Math.max(-maxY, Math.min(maxY, baseY + event.gamma / 45 * maxY));
        targetX = Math.max(
          -maxX,
          Math.min(maxX, baseX + ((event.beta || 0) - 20) / 45 * -maxX)
        );
      }, { passive: true });
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopAnimation();
      } else {
        startAnimation();
      }
    });

    startAnimation();
  }

})();
